export const MODULE_NAME = 'tracking';
export const TRACKING_ROUTE = `/${MODULE_NAME}`;
